import { render, staticRenderFns } from "./EditLabels.vue?vue&type=template&id=0c1c8f2e&scoped=true&"
import script from "./EditLabels.vue?vue&type=script&lang=js&"
export * from "./EditLabels.vue?vue&type=script&lang=js&"
import style0 from "./EditLabels.vue?vue&type=style&index=0&id=0c1c8f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c8f2e",
  null
  
)

export default component.exports